// dd-manager.ts 3.0.0 @preserve

/**
 * https://gridstackjs.com/
 * (c) 2020 rhlin, Alain Dumesny
 * gridstack.js may be freely distributed under the MIT license.
*/
import { DDDraggable } from './dd-draggable';

export class DDManager {
  static dragElement: DDDraggable;
}
